import { crmmApi } from 'dashboard/helper/crmmApi';
export async function campanhaPost(feature, body) {
  return crmmApi(feature, body);
}
